import { forwardRef, type InputHTMLAttributes } from 'react';
import './Input.scss';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  hint?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, hint, className = '', id, ...rest }, ref) => {
    const inputId = id ?? `input-${rest.name ?? Math.random().toString(36).slice(2, 8)}`;
    return (
      <div className={`input-field ${className}`}>
        {label && (
          <label htmlFor={inputId} className="input-field__label">
            {label}
          </label>
        )}
        <input
          ref={ref}
          id={inputId}
          className={`input-field__input${error ? ' input-field__input--error' : ''}`}
          {...rest}
        />
        {error ? (
          <span className="input-field__error">{error}</span>
        ) : hint ? (
          <span className="input-field__hint">{hint}</span>
        ) : null}
      </div>
    );
  },
);
Input.displayName = 'Input';
